import { icons } from '@/images';

// ============================================================================
// Feature Flags
// ============================================================================

export const FEATURE_FLAGS = {
  /** Enable sorting and filtering UI in flight listing views */
  SHOW_SORT_AND_FILTER: false,
  STEPPER_STEP_CLICKABLE: false,
  /** Enable async task polling (e.g., flight search). When false, asyncTask in stream response is ignored. */
  ASYNC_TASK_POLLING: true,
  /** Use mock poll responses instead of real API. Only works when ASYNC_TASK_POLLING is true. */
  USE_MOCK_ASYNC_POLL: false,
  /** Show a consent popup ("Please verify your details") before initiating payment. When false, payment is initiated directly. */
  SHOW_PAYMENT_CONSENT_POPUP: true,
} as const;

export const CHOOSE_ROUTES = [
  {
    route_number: 1,
    tag: 'Fastest',
    airlines: [
      {
        name: 'Vietjet Air',
        logo: icons.VietjetAirIcon,
      },
      {
        name: 'Singapore Airlines',
        logo: icons.SingaporeAirlinesIcon,
      },
    ],
    route: 'Direct to Ho Chi Minh',
    approx_price: '₹20k - ₹25k',
    duration: '4h 55m',
    stops: 'Non-Stop',
    luggage_allowance: '7 kg cabin + 2 x 30kg luggage',
    why_choose_this: 'Ideal if you want to save time and reach Hanoi quickly without any layovers.',
  },
  {
    route_number: 2,
    tag: 'Cheapest',
    airlines: [
      {
        name: 'AirAsia',
        logo: icons.AirAsiaIcon,
      },
      {
        name: 'Singapore Airlines',
        logo: icons.SingaporeAirlinesIcon,
      },
      {
        name: 'Emirates',
        logo: icons.EmiratesIcon,
      },
    ],
    route: 'Direct to Hanoi',
    approx_price: '₹10k - ₹15k',
    duration: '5h 39m',
    stops: 'Non-Stop',
    luggage_allowance: '20 kg checked + 7 kg cabin (with Value Pack)',
    why_choose_this:
      'Best pick if you’re looking for the lowest fare option and a direct connection to Ho Chi Minh.',
  },
  {
    route_number: 3,
    tag: 'Comfort',
    airlines: [
      {
        name: 'Cathay Pacific',
        logo: icons.CathayPacificIcon,
      },
      {
        name: 'Singapore Airlines',
        logo: icons.SingaporeAirlinesIcon,
      },
      {
        name: 'Emirates',
        logo: icons.EmiratesIcon,
      },
    ],
    route: 'Via Bangkok to Ho Chi Minh',
    approx_price: '₹25k - ₹35k+',
    duration: '8h - 10h',
    stops: '1 Stop',
    luggage_allowance: 'Usually 20-25 kg checked + cabin',
    why_choose_this:
      'A smoother journey with a comfortable layover in Bangkok, giving you flexibility and better connection timings.',
  },
];

export const FLIGHT_ROUTE_PATH = [
  {
    code: 'BLR',
    city: 'Bangalore',
    country: 'India',
  },
  {
    code: 'SGN',
    city: 'Ho Chi Minh City',
    country: 'Vietnam',
  },
  {
    code: 'BLR',
    city: 'Bangalore',
    country: 'India',
  },
];

export const SELECT_FLIGHT_LISTING = [
  {
    oneWay: {
      id: 'flt1',
      airline: {
        name: 'Vietjet Airlines',
        flightNumber: 'VJ 230',
        logo: icons.VietjetAirIcon,
      },
      travelClass: 'Economy',
      date: '22 Oct 2025',
      departure: {
        time: '09:00AM',
        airport: 'BLR',
      },
      arrival: {
        time: '01:10PM',
        airport: 'SGN',
      },
      duration: '4hrs 44m',
      stops: 'Non-Stop',
    },
    roundTrip: {
      id: 'flt2',
      airline: {
        name: 'Vietjet Airlines',
        flightNumber: 'VJ 230',
        logo: icons.VietjetAirIcon,
      },
      travelClass: 'Economy',
      date: '22 Oct 2025',
      departure: {
        time: '09:00AM',
        airport: 'BLR',
      },
      arrival: {
        time: '01:10PM',
        airport: 'SGN',
      },
      duration: '4hrs 44m',
      stops: 'Non-Stop',
    },
    baggage: {
      baggageInfo: [
        {
          title: '1 Cabin',
          weight: '7 kgs',
          type: 'Cabin',
          status: 'Allowed',
          image: icons.BaggageIcon,
        },
        {
          title: '1 Check-In',
          weight: '33 kgs each',
          type: 'Check-In',
          status: 'Allowed',
          image: icons.BaggageIcon,
        },
      ],
      note: {
        title: 'NOTE',
        message:
          "You'll earn only half the usual loyalty points (about 12,800) since it's on different carriers",
      },
    },
    priceInfo: {
      amount: '₹16,590',
      per: 'Person',
    },
    detailsLinkText: 'VIEW DETAILS',
    addToCartText: 'ADD TO CART',
  },
  {
    oneWay: {
      id: 'flt1',
      airline: {
        name: 'Vietjet Airlines',
        flightNumber: 'VJ 230',
        logo: icons.VietjetAirIcon,
      },
      travelClass: 'Economy',
      date: '22 Oct 2025',
      departure: {
        time: '09:00AM',
        airport: 'BLR',
      },
      arrival: {
        time: '01:10PM',
        airport: 'SGN',
      },
      duration: '4hrs 44m',
      stops: 'Non-Stop',
    },
    roundTrip: {
      id: 'flt2',
      airline: {
        name: 'Vietjet Airlines',
        flightNumber: 'VJ 230',
        logo: icons.VietjetAirIcon,
      },
      travelClass: 'Economy',
      date: '22 Oct 2025',
      departure: {
        time: '09:00AM',
        airport: 'BLR',
      },
      arrival: {
        time: '01:10PM',
        airport: 'SGN',
      },
      duration: '4hrs 44m',
      stops: 'Non-Stop',
    },
    baggage: {
      baggageInfo: [
        {
          title: '1 Cabin',
          weight: '7 kgs',
          type: 'Cabin',
          status: 'Allowed',
          image: icons.BaggageIcon,
        },
        {
          title: '1 Check-In',
          weight: '33 kgs each',
          type: 'Check-In',
          status: 'Allowed',
          image: icons.BaggageIcon,
        },
      ],
      note: {
        title: 'NOTE',
        message:
          "You'll earn only half the usual loyalty points (about 12,800) since it's on different carriers",
      },
    },
    priceInfo: {
      amount: '₹16,590',
      per: 'Person',
    },
    detailsLinkText: 'VIEW DETAILS',
    addToCartText: 'ADD TO CART',
  },
  {
    oneWay: {
      id: 'flt1',
      airline: {
        name: 'Vietjet Airlines',
        flightNumber: 'VJ 230',
        logo: icons.VietjetAirIcon,
      },
      travelClass: 'Economy',
      date: '22 Oct 2025',
      departure: {
        time: '09:00AM',
        airport: 'BLR',
      },
      arrival: {
        time: '01:10PM',
        airport: 'SGN',
      },
      duration: '4hrs 44m',
      stops: 'Non-Stop',
    },
    roundTrip: {
      id: 'flt2',
      airline: {
        name: 'Vietjet Airlines',
        flightNumber: 'VJ 230',
        logo: icons.VietjetAirIcon,
      },
      travelClass: 'Economy',
      date: '22 Oct 2025',
      departure: {
        time: '09:00AM',
        airport: 'BLR',
      },
      arrival: {
        time: '01:10PM',
        airport: 'SGN',
      },
      duration: '4hrs 44m',
      stops: 'Non-Stop',
    },
    baggage: {
      baggageInfo: [
        {
          title: '1 Cabin',
          weight: '7 kgs',
          type: 'Cabin',
          status: 'Allowed',
          image: icons.BaggageIcon,
        },
        {
          title: '1 Check-In',
          weight: '33 kgs each',
          type: 'Check-In',
          status: 'Allowed',
          image: icons.BaggageIcon,
        },
      ],
      note: {
        title: 'NOTE',
        message:
          "You'll earn only half the usual loyalty points (about 12,800) since it's on different carriers",
      },
    },
    priceInfo: {
      amount: '₹16,590',
      per: 'Person',
    },
    detailsLinkText: 'VIEW DETAILS',
    addToCartText: 'ADD TO CART',
  },
];

export const SELECT_FLIGHT_LISTING_ONEWAY = [
  {
    id: 'DEL$AMD$2025-12-30 18:50$6E-5317-0',
    origin: {
      code: 'DEL',
      city: 'New Delhi',
      country: 'India',
      displayName: 'New Delhi, India',
    },
    destination: {
      code: 'AMD',
      city: 'Ahmedabad',
      country: 'India',
      displayName: 'Ahmedabad, India',
    },
    airline: {
      code: '6E',
      name: 'IndiGo',
      logoUrl: '/images/airlines/6E.webp',
    },
    flightNumber: '5317',
    flightNumberFormatted: 'IndiGo (5317)',
    class: 'Economy',
    departure: {
      timestamp: '2025-12-30T13:20:00.000Z',
      timeFormatted: '6:50 PM',
      dateFormatted: '30 Dec 2025',
    },
    arrival: {
      timestamp: '2025-12-30T15:05:00.000Z',
      timeFormatted: '8:35 PM',
      dateFormatted: '30 Dec 2025',
    },
    duration: {
      minutes: 0,
      formatted: '0m',
    },
    stops: {
      count: 1,
      label: '1 Stop',
    },
  },
];

export const SELECT_FLIGHT_LISTING_ROUNDTRIP = [
  {
    id: 'DEL$AMD$2025-12-30 18:50$6E-5317-0',
    origin: {
      code: 'DEL',
      city: 'New Delhi',
      country: 'India',
      displayName: 'New Delhi, India',
    },
    destination: {
      code: 'AMD',
      city: 'Ahmedabad',
      country: 'India',
      displayName: 'Ahmedabad, India',
    },
    airline: {
      code: '6E',
      name: 'IndiGo',
      logoUrl: icons.AirAsiaIcon,
    },
    flightNumber: '5317',
    flightNumberFormatted: 'IndiGo (5317)',
    class: 'Economy',
    departure: {
      timestamp: '2025-12-30T13:20:00.000Z',
      timeFormatted: '6:50 PM',
      dateFormatted: '30 Dec 2025',
    },
    arrival: {
      timestamp: '2025-12-30T15:05:00.000Z',
      timeFormatted: '8:35 PM',
      dateFormatted: '30 Dec 2025',
    },
    duration: {
      minutes: 0,
      formatted: '0m',
    },
    stops: {
      count: 1,
      label: '1 Stop',
    },
  },
  {
    id: 'AMD$GOI$2025-12-31 01:05$6E-6418-1',
    origin: {
      code: 'AMD',
      city: 'Ahmedabad',
      country: 'India',
      displayName: 'Ahmedabad, India',
    },
    destination: {
      code: 'GOI',
      city: 'Goa - Dabolim Airport',
      country: 'India',
      displayName: 'Goa - Dabolim Airport, India',
    },
    airline: {
      code: '6E',
      name: 'IndiGo',
      logoUrl: icons.AirAsiaIcon,
    },
    flightNumber: '6418',
    flightNumberFormatted: 'IndiGo (6418)',
    class: 'Economy',
    departure: {
      timestamp: '2025-12-30T19:35:00.000Z',
      timeFormatted: '1:05 AM',
      dateFormatted: '31 Dec 2025',
    },
    arrival: {
      timestamp: '2025-12-30T21:15:00.000Z',
      timeFormatted: '2:45 AM',
      dateFormatted: '31 Dec 2025',
    },
    duration: {
      minutes: 0,
      formatted: '0m',
    },
    stops: {
      count: 0,
      label: 'Non-Stop',
    },
  },
];

export const FLIGHT_REVIEW_BAGGAGE = {
  cabin: {
    count: 1,
    weightKg: 7,
    type: 'cabin' as const,
    countFormatted: '1 Cabin',
    weightFormatted: '7 kgs',
    iconUrl: '/images/ic-baggage.webp',
    cancellation: {
      allowed: false,
      label: 'Not Allowed',
    },
  },
  checkin: {
    count: 2,
    weightKg: 33,
    type: 'checkin' as const,
    countFormatted: '2 Check-In',
    weightFormatted: '33 kgs each',
    iconUrl: '/images/ic-baggage.webp',
    cancellation: {
      allowed: true,
      label: 'Allowed',
    },
  },
};

export const SELECTED_FLIGHT_CARD_DATA = {
  airline: {
    name: 'Vietjet Airlines',
    flightNumber: 'VJ 230',
    logo: icons.VietjetAirIcon,
  },
  travelClass: 'Economy',
  departureDate: '22 Oct 2025',
  duration: '4hrs 44m',
  stops: 'Non-Stop',
  routes: [
    {
      code: 'BLR',
      city: 'Bangalore',
      country: 'India',
      time: '09:00AM',
    },
    {
      code: 'SGN',
      city: 'Ho Chi Minh City',
      country: 'Vietnam',
      time: '01:10PM',
    },
  ],
  amenities: [
    {
      title: '3-3 Layout',
      image: icons.TickIcon,
    },
    {
      title: 'Standard Recliner (31" Legroom)',
      image: icons.TickIcon,
    },
    {
      title: 'Complimentary Beverages',
      image: icons.TickIcon,
    },
  ],
  cta: '+ SEE MORE DETAILS',
};

export const CANCELLATION_REFUND_DATA = {
  description: 'Get refund of ₹14,353 on cancellation up to 4 days before departure',
  refundTimeline: [
    {
      date: '1 Sep',
      label: 'Today',
      refundText: 'Get refund of ₹2,353',
      refundAvailable: true,
    },
    {
      date: '18 Sep',
      label: '',
      refundText: 'No Refund',
      refundAvailable: false,
    },
    { date: '22 Oct', label: 'Departure', refundAvailable: false },
  ],
};

export const DATA_CHANGE_FEE = {
  description:
    'Airline fee of ₹2,250 + fare difference on date change up to 4 days before departure',
  dateRange: {
    startDate: '1 FEB',
    endDate: '18 FEB',
    rule: {
      label: 'Date Change Fee',
      details: '@ ₹2,250 + fare difference',
    },
  },
  restrictionRange: {
    startDate: '19 FEB',
    endDate: '22 FEB',
    rule: {
      label: 'Date Change Not Allowed',
    },
  },
};

export const TRAVELLER_DETAILS = [
  {
    id: 'pax1',
    name: 'Vineel Thota',
    relation: 'You',
    email: 'vineel@gmail.com',
    phone: '+91-9492002772',
    selected: false,
  },
  {
    id: 'pax2',
    name: 'Abhinav Mittal',
    relation: 'Brother',
    email: 'abhiimit@gmail.com',
    phone: '+91-7036240751',
    selected: false,
  },
  {
    id: 'pax3',
    name: 'Karan Darji',
    relation: 'Brother',
    email: 'karan@gmail.com',
    phone: '+91-9492002772',
    selected: false,
  },
];

export const SELECT_SEAT_CARD_DATA = {
  title: 'Select Seat',
  count: 1,
  fromCity: 'BLR',
  toCity: 'SGN',
  date: '22 Oct 2025',
};

export const ROUND_TRIP_FLIGHT_CARD_DATA = {
  departureFlights: [
    {
      id: 'flt1',
      date: '22 October 2025',
      time: '09:00 AM',
      duration: '4hrs 44m',
      type: 'Non-Stop',
      travelClass: 'Economy',
      airline: icons.VietjetAirIcon,
      from: {
        code: 'BLR',
        city: 'Bangalore',
        country: 'India',
      },
      to: {
        code: 'SGN',
        city: 'Ho Chi Minh City',
        country: 'Vietnam',
      },
    },
  ],
  returnFlights: [
    {
      id: 'flt2',
      date: '03 November 2025',
      time: '01:10 AM',
      duration: '4hrs 44m',
      type: 'Non-Stop',
      travelClass: 'Business Class',
      airline: icons.VietjetAirIcon,
      from: {
        code: 'SGN',
        city: 'Ho Chi Minh City',
        country: 'Vietnam',
      },
      to: {
        code: 'BLR',
        city: 'Bangalore',
        country: 'India',
      },
    },
  ],
  actions: {
    primary: 'PAY NOW',
    secondary: 'ADD TO CART',
  },
};

export const FARE_OPTION_DATA = [
  {
    id: 'fare1',
    mmtSpecialFare: true,
    price: '₹ 16,590',
    per: 'per adult',
    benefits: {
      worth: '₹ 3,150',
      included: true,
      details: ['Free date change', 'Free cancellation'],
    },
    features: [
      { label: 'Cabin', value: '7Kgs', icon: icons.TickMarkIcon },
      { label: 'Check-in', value: '2x15Kgs', icon: icons.TickMarkIcon },
      { label: 'Seat', value: 'Free seats available', icon: icons.TickMarkIcon },
      { label: 'Meal', value: 'Get complimentary meals', icon: icons.TickMarkIcon },
    ],
    cta: [
      { label: 'Lock Price', type: 'outline' },
      { label: 'Selected', type: 'solid' },
    ],
  },
  {
    id: 'fare2',
    type: 'Eco Value',
    price: '₹ 16,098',
    per: 'per adult',
    features: [
      { label: 'Cabin', value: '7Kgs', icon: icons.TickMarkIcon },
      { label: 'Check-in', value: '15Kgs', icon: icons.TickMarkIcon },
      { label: 'Cancellation', value: 'Fee starting ₹4,000', icon: icons.MinusMarkIcon },
      { label: 'Date change', value: 'Fee starting ₹3,150', icon: icons.MinusMarkIcon },
    ],
    viewDetails: 'View Seat, meal and delight',
    cta: [
      { label: 'Lock Price', type: 'outline' },
      { label: 'Select', type: 'solid' },
    ],
  },
  {
    id: 'fare3',
    type: 'Eco Classic',
    price: '₹ 6,590',
    per: 'per adult',
    features: [
      { label: 'Cabin', value: '7Kgs', icon: icons.TickMarkIcon },
      { label: 'Check-in', value: '15Kgs', icon: icons.TickMarkIcon },
      { label: 'Cancellation', value: 'Fee starting ₹3,500', icon: icons.MinusMarkIcon },
      { label: 'Date change', value: 'Fee starting ₹3,150', icon: icons.MinusMarkIcon },
    ],
    viewDetails: 'View Seat, meal and delight',
    cta: [
      { label: 'Lock Price', type: 'outline' },
      { label: 'Select', type: 'solid' },
    ],
  },
];
